import { z } from 'zod'

/**
 * Preferências de cada pessoa (ADR 0040): o som das mensagens e o tema.
 *
 * Moram na conta, e não no navegador: quem troca de computador encontra o
 * sistema do jeito que deixou. Não são permissões: ninguém controla o som de
 * outra pessoa (questionário de 03/10/2026, "cada um, para si").
 */

export const TEMAS = ['claro', 'escuro'] as const
export type Tema = (typeof TEMAS)[number]

export interface PreferenciasUsuario {
  /** Toque quando chega mensagem numa conversa que é da pessoa. */
  somMinhas: boolean
  /** Toque parecido, mas outro, quando chega mensagem de conversa sem dono. */
  somFila: boolean
  /** De 0 a 1. */
  volumeSom: number
  tema: Tema
}

export const PREFERENCIAS_PADRAO: PreferenciasUsuario = {
  somMinhas: true,
  somFila: true,
  volumeSom: 0.6,
  tema: 'claro',
}

export const alterarPreferenciasSchema = z
  .object({
    somMinhas: z.boolean(),
    somFila: z.boolean(),
    volumeSom: z.number().min(0).max(1),
    tema: z.enum(TEMAS),
  })
  .partial()
  .strict()
export type AlterarPreferenciasEntrada = z.infer<typeof alterarPreferenciasSchema>

/**
 * O que está gravado, completado com o padrão. A coluna nasce `{}` e cada
 * preferência nova entra aqui sem migração: quem nunca mexeu fica no padrão.
 * Valor gravado que não confere (versão antiga, edição à mão) também cai no
 * padrão, campo a campo, em vez de derrubar a sessão.
 */
export function lerPreferencias(bruto: unknown): PreferenciasUsuario {
  const gravado = typeof bruto === 'object' && bruto !== null ? bruto : {}
  const resultado = { ...PREFERENCIAS_PADRAO }
  for (const [chave, valor] of Object.entries(gravado)) {
    const conferido = alterarPreferenciasSchema.safeParse({ [chave]: valor })
    if (conferido.success) Object.assign(resultado, conferido.data)
  }
  return resultado
}
